import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/img/map_thumb.png'


const _hoisted_1 = { class: "block w-full mb-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "flex locationDetailRow" }
const _hoisted_4 = { class: "detailAttribute" }
const _hoisted_5 = { class: "flex locationDetailRow" }
const _hoisted_6 = { class: "detailAttribute" }
const _hoisted_7 = { class: "flex locationDetailRow" }
const _hoisted_8 = { class: "detailAttribute" }
const _hoisted_9 = { class: "flex locationDetailRow" }
const _hoisted_10 = { class: "detailAttribute" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex locationDetailRow" }
const _hoisted_13 = { class: "detailAttribute" }
const _hoisted_14 = { class: "flex locationDetailRow" }
const _hoisted_15 = { class: "detailAttribute" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "w-full h-64" }
const _hoisted_19 = {
  key: 0,
  class: "w-full h-64"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["alt"]

import {toRef} from "vue";
import {useI18n} from "vue-i18n";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip
} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantDetailsPopup',
  props: {
  data: Object
},
  setup(__props) {

const { t } = useI18n();
let zoom = 15;

const props = __props
const popupData = toRef(props, 'data');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.name')), 1),
            _createElementVNode("div", null, _toDisplayString(popupData.value.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.street')), 1),
            _createElementVNode("div", null, _toDisplayString(popupData.value.street) + " " + _toDisplayString(popupData.value.houseNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.postalcode')), 1),
            _createElementVNode("div", null, _toDisplayString(popupData.value.postalCode) + " " + _toDisplayString(popupData.value.city), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.email')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                href: `mailto:${popupData.value.email}`
              }, _toDisplayString(popupData.value.email), 9, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.phoneNumber')), 1),
            _createElementVNode("div", null, _toDisplayString(popupData.value.phoneNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.gps')), 1),
            (popupData.value.latitude && popupData.value.longitude)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(popupData.value.latitude) + " | " + _toDisplayString(popupData.value.longitude), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('plantManagment.popups.plantDetails.noGpsData')), 1))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, [
            (popupData.value.latitude && popupData.value.longitude)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_unref(LMap), {
                    modelValue: _unref(zoom),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(zoom) ? (zoom).value = $event : zoom = $event)),
                    zoom: _unref(zoom),
                    "onUpdate:zoom": _cache[1] || (_cache[1] = ($event: any) => (_isRef(zoom) ? (zoom).value = $event : zoom = $event)),
                    center: [popupData.value.latitude, popupData.value.longitude]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LTileLayer), { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                      _createVNode(_unref(LMarker), {
                        "lat-lng": [popupData.value.latitude, popupData.value.longitude]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(LTooltip), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(popupData.value.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["lat-lng"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "zoom", "center"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("img", {
                    class: "w-full h-64",
                    src: _imports_0,
                    alt: _unref(t)('plantManagment.popups.plantDetails.noGpsData')
                  }, null, 8, _hoisted_21)
                ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})